export default "__VITE_ASSET__Cqq8Dc5W__"